import { createContext, useCallback, useContext, useState } from 'react';
import * as investorsService from '../../services/Admin/investorsService';
import swal from 'sweetalert';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { Translator } from '@components';
import { useNavigate } from 'react-router-dom';

export const InvestorsContext = createContext({});

const InvestorsProvider = ({ children }) => {
  const { t } = useTranslation();
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [investors, setInvestors] = useState();
  const [investor, setInvestor] = useState();
  const [page, setPage] = useState();
  const [totalPages, setTotalPages] = useState(0);

  const getInvestors = useCallback(async (page, type) => {
    setLoading(true);

    try {
      const params = {
        page: page ? page - 1 : 0,
        pageSize: 12,
        type,
      };

      const { data } = await investorsService.getAllInvestors(params);
      setTotalPages(Math.ceil(data.total / params.pageSize));
      const formatedUsers = data.data.map((user) => {
        return {
          ...user, statusFormated: t(`types.userTypes.${user.status}`),
          action: (
            <Button
              className="text-nowrap w-auto"
              variant="outline-primary"
              size="lg"
              id="btn-outlined"
              onClick={
                () => {
                  navigate(`/investors/${user.userId}`);
                }
              }
            >
              <Translator path={'pages.investors.details'} />
            </Button>
          )
        };
      }
      );
      setInvestors(formatedUsers);
    } catch (error) {
      const errTitle = t('pages.investors.apiErr.title');
      const errBody = t('pages.investors.apiErr.body');
      swal(errTitle, errBody, 'error');
    } finally {
      setLoading(false);
    }
  }, []);

  const getInvestorDetail = useCallback(async (userId) => {
    setLoading(true);
    try {
      const data = await investorsService.getInvestor(userId);
      setInvestor(data.data);
    } catch (error) {
      const errTitle = t('pages.investors.apiErr.title');
      const errBody = t('pages.investors.apiErr.body');
      swal(errTitle, errBody, 'error');
    } finally {
      setLoading(false);
    }
  }, []);

  const approveInvestor = useCallback(async (userId) => {
    setLoading(true);
    try {
      const data = await investorsService.approveInvestor(userId);
      const successHeader = t('pages.investors.approveSwal.success');
      const successMessage = t('pages.investors.approveSwal.sucessMessage');
      swal(successHeader, successMessage, 'success');
      getInvestorDetail(userId);
    } catch (error) {
      const errTitle = t('pages.investors.approveError.title');
      const errBody = t('pages.investors.approveError.body');
      swal(errTitle, errBody, 'error');
    } finally {
      setLoading(false);
    }
  }, []);


  return (
    <InvestorsContext.Provider
      value={{
        loading,
        investors,
        getInvestors,
        setInvestors,
        totalPages,
        page,
        setPage,
        investor,
        getInvestorDetail,
        approveInvestor,
      }}
    >
      {children}
    </InvestorsContext.Provider>
  );
};

const useInvestors = () => {
  return useContext(InvestorsContext);
};

export { InvestorsProvider, useInvestors };
